let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4FFTC")).then(() => parcelRequire('3sddq'));